/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Component, Input, TemplateRef } from "@angular/core";
import { ɵb as NzRibbonComponent } from "ng-zorro-antd/badge";

@Component({
  selector: "ui-ribbon",
  exportAs: "uiRibbon",
  templateUrl: "./ribbon.component.html",
})
export class UiRibbonComponent extends NzRibbonComponent {
  @Input("uiColor") public nzColor: string | undefined;
  @Input("uiPlacement") public nzPlacement: "start" | "end" = "end";
  @Input("uiText") public nzText: string | TemplateRef<void> | null = null;
}
